import { bind } from 'decko'
import BaseApi from './baseApi'
import {GetConfiguration} from '../../constants/endpoints.constants'
export default class Public extends BaseApi {
  @bind
  async getConfiguration(data) {
    return await this.http.get(GetConfiguration(), data)
  }
}
